import * as React from "react";
const CaretDown = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 18", fill: "currentColor", width: size || "12", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m6 12 4-6H2l4 6Z" }));
CaretDown.displayName = "CaretDown";
var CaretDown_default = CaretDown;
export {
  CaretDown_default as default
};
